import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-rater-assessment',
  templateUrl: './rater-assessment.component.html',
  styleUrls: ['./rater-assessment.component.scss']
})
export class RaterAssessmentComponent implements OnInit {
    nextQuestions: boolean = false;
    questions: string[] =
    [
        "Adapt to change",
        "Digest new information quickly, and adjust course appropriately",
        "Support your development",
        "Digest new information quickly, and adjust course appropriately"
    ];

    questions2: string[] =
    [
        "Allow others to solve challenges, as opposed to jumping into fix-it mode to do it him/herself",
        "Be aware of his/her effect on other people",
        "Be confident in his/her own abilities",
        "Trust those around him/her"
    ];

    tableTitles: string[] =
    [
        "Very poor",
        "Below average",
        "Average",
        "Above Average",
        "Excellent"
    ];

    tableTitles2: string[] =
    [
        "Never",
        "Rarely",
        "Sometimes",
        "Usually",
        "Always"
    ];

    _assessmentEnd: boolean = false;
    finalMessage: string = "Thank you for your participation!";
    from: string;
    from_clients: boolean = false;

    constructor(private activatedRoute: ActivatedRoute) {
        this.activatedRoute.params.subscribe(params => {
            console.log(params['id']);
            this.from = params['id'];

            //if (this.from == '360_assessments') {
            //    this.from_clients = true;
            //}
        });
    }

  ngOnInit() {
  }

  selectCircle(event: any) {
      $(event.target).addClass('selected');
      console.log(event);
      let children = event.target.parentNode.parentNode.children.length;
      for (let i = 0; i < children; i++) {
          event.target.parentNode.parentNode.children[i].children["0"].classList.remove('selected');
      }
      event.target.classList.add('selected');
  }

  next() {
      this.nextQuestions = true;
  }

  assessmentEnd() {
      this._assessmentEnd = true;
  }

}
